/** biome-ignore-all lint/style/noMagicNumbers: TODO: fix */
import { TRAILER_STATUS } from '@/views/pages/Savers/TrailerManagement/constants';

export const calculateLinearFeet = (weight, type) => {
  const w = Number.parseFloat(weight) || 0;
  return type ? (w * (type === 7 || type === 2 ? 2 : 1)) / 1000 : 0;
};

export const mergeByKeys = (arr, keysToMerge) => {
  if (!arr || arr.length === 0) {
    return [];
  }

  const mergedObject = {};

  for (const key of keysToMerge) {
    mergedObject[key] = [];
  }

  for (const item of arr) {
    for (const [key, value] of Object.entries(item)) {
      if (keysToMerge.includes(key)) {
        if (value) {
          const valuesToMerge = value instanceof Object ? value : [value];
          mergedObject[key].push(...valuesToMerge);
        }
      } else if (!(key in mergedObject)) {
        mergedObject[key] = value;
      }
    }
  }

  return [mergedObject];
};

export const getTrailerStatusColor = (status) => {
  if (status) {
    const newStatus = status.trim();
    switch (newStatus) {
      // Assigned - Yellow
      case TRAILER_STATUS.ASSIGNED:
        return '#ffffcc';

      // Planned/Unconfirmed - Brown
      case TRAILER_STATUS.PLANNED:
      case TRAILER_STATUS.UNCONFIRMED:
        return '#b86c3c94';

      // Broken/Problem - Red
      case TRAILER_STATUS.BROKEN:
        return '#ff9999';

      // No color for these statuses
      case TRAILER_STATUS.RECEIVED:
      case TRAILER_STATUS.UNASSIGNED:
        return '';
      default:
        return '';
    }
  }
  return '';
};

export const getTrailerLabel = (size, options) => {
  const match = options?.find((val) => val.value === size);
  return match?.label || size;
};
